/**
 * Это модуль для простых страниц
 * */

import axios from 'axios'
/** Модуль для формирования параметров запроса axios
 * qs.stringify({ id: data.id }),
 */
import qs from 'qs';
import {jsonHeader,wwwFormHeader} from '@/helpers/axiosHeaders'
import VueCookies from 'vue-cookies'
import Vue from 'vue'

const state = {
    forms: {
        auth: {
            fields: {
                login: {
                    name: 'login',
                    value: '',
                    required: true,
                    error: false,
                    errorText: 'Некорректный номер',
                    disabled: false,
                    focus: false,
                },
                password: {
                    name: 'password',
                    value: '',
                    required: true,
                    error: false,
                    errorText: 'Неверный код',
                    disabled: false,
                    focus: false,
                }
            },
            step: 1,
            timer: {
                time: 0,
                timeDefault: 30,
                intervalId: false,
                smsBan: false,
                timeBan: 0
            }
        },
        registration: {
            fields: {
                firstName: {
                    name: 'firstName',
                    value: '',
                    required: true,
                    error: false,
                    errorText: 'Обязательное поле',
                    disabled: false
                },
                /*lastName: {
                    name: 'lastName',
                    value: '',
                    required: true,
                    error: false,
                    errorText: 'Обязательное поле',
                    disabled: false
                },
                secondName: {
                    name: 'secondName',
                    value: '',
                    required: true,
                    error: false,
                    errorText: 'Обязательное поле',
                    disabled: false
                },
                email: {
                    name: 'email',
                    value: '',
                    required: true,
                    error: false,
                    errorText: 'Некорректный e-mail',
                    disabled: false
                }*/
            },
        }
    },
    isBanned: false,
    isBannedPartner: false,
    isBannedPermanent: false,
    isRedirect: true,
    isValidPhone: true,
    isNoSuccess: false,
    isNoSuccessSection: false,
}

// getters
const getters = {
    getList: state => id => {
        return state.data;
    },
    token(){
        return localStorage.getItem('token') !== 'false' && localStorage.getItem('token') !== null && localStorage.getItem('token') !== undefined ? localStorage.getItem('token') : false;
    },
}

const actions = {
    startTimer(context, data) {
        if(state.forms.auth.timer.intervalId && state.forms.auth.timer.time === 0) {
            clearInterval(state.forms.auth.timer.intervalId);
            context.commit('clearInterval');
        }

        if(!state.forms.auth.timer.intervalId) {
            let time = state.forms.auth.timer.timeDefault;
            if(!!data && data.time) {
                time = data.time;
            }

            context.commit('setTimerTime', time);
            let timer = setInterval(function () {
                if(state.forms.auth.timer.time > 0) {
                    context.commit('decrementTimerTime');
                } else {
                    clearInterval(state.forms.auth.timer.intervalId);
                    context.commit('clearInterval');
                }
            }, 1000);
            context.commit('setInterval',timer);
        }
    },
    checkLogin(context, data) {
        return new Promise((resolve, reject) => {
            let params = {
                login: context.state.forms.auth.fields.login.value,
                isTeam: data.isTeam
            };
            if(data.isPartner) {
                params.checkPartner = true;
            }
            if(data.isLK) {
                params.checkLK = true;
            }
            axios.post(process.env.VUE_APP_API_PATH+'/public/users/',{},
            {
                withCredentials: true,
                params:params ,
                paramsSerializer: function(params) {
                    return qs.stringify(params, {arrayFormat: 'repeat'})
                },
                headers: jsonHeader,
            }).then(response => {
                if(typeof response.data === 'object' && +response.data.error === 0) {
                    if(data.isPartner && response.data.result.ban !== undefined && response.data.result.ban.banType === 'partner') {
                        context.commit('setBanPartner',true);
                        if(response.data.result.partner){
                            context.commit('partner/setCurrent',{item:response.data.result.partner},{root:true});
                        }
                        if(response.data.result.partner && response.data.result.partner.success === false){
                            context.commit('partner/setLoaded', true, {root:true});
                        }
                    }
                    else if(response.data.result.ban !== undefined && response.data.result.ban.banType === 'sms') {
                        context.commit('setSmsBan',response.data.result.ban);
                    } else {
                        if(response.data.result.noValidPhone){
                            context.commit('setIsValidPhone',false);
                        }
                        else if(!!response.data.result.threshold && response.data.result.threshold.time > 0){
                            context.dispatch('startTimer',{time:response.data.result.threshold.time});
                        } else {
                            context.dispatch('startTimer',{time: state.forms.auth.timer.timeDefault});
                        }

                    }

                } else if(response.data.error > 0) {
                    switch (+response.data.error ) {
                        case 400:
                            context.commit('setFormAuthError',{
                                name: context.state.forms.auth.fields.login.name,
                                value: true
                            });
                            break;
                        case 403:
                            context.commit('setBan',true);
                            break;
                        case 401:
                            if(data.isPartner || data.isLK) {
                                context.commit('setIsNoSuccess',true);
                            } else {
                                context.commit('setBanPermanent',true);
                                context.dispatch('popups/open',{name:context.rootState.popups.items.userIsBannedPermanent.name},{root:true});
                            }

                            break;
                    }

                }
                resolve();

            }).catch(function (error) {
                context.commit('popups/open', {name: context.rootState.popups.items.somethingWentWrong.name}, {root: true});
                reject();
            });
        });
    },
    getToken(context, data){
        return new Promise((resolve, reject) => {
            axios.post(process.env.VUE_APP_API_PATH+'/public/tokens/',{},{
                headers: jsonHeader,
                withCredentials: true,
                params: {
                    login: context.state.forms.auth.fields.login.value,
                    password: context.state.forms.auth.fields.password.value,
                    isTeam: data.isTeam
                },
                paramsSerializer: function(params) {
                    return qs.stringify(params, {arrayFormat: 'repeat'})
                },
            }).then(response => {
                if(typeof response.data === 'object' && +response.data.error === 0) {
                    if(!!response.data.result.token){
                        context.commit('setFormAuthField', {name:'password',value: ''});
                        localStorage.setItem('token', response.data.result.token);
                        window.app.localStorage.token = response.data.result.token;
                        let user = response.data.result.user;
                        context.commit('users/setUser',{user:user},{root:true});
                        if(user.firstName /*&& user.secondName && user.lastName && user.email*/ && !data.isOrder){
                        }
                        resolve()
                    }
                } else if(response.data.error > 0) {
                    switch (+response.data.error ) {
                        case 401:
                            context.commit('setFormAuthError',{
                                name: context.state.forms.auth.fields.password.name,
                                value: true
                            });
                            break;
                        case 403:
                            context.commit('setBan',true);
                            break;
                    }

                }
            }).catch(function (error) {
                context.commit('popups/open', {name: context.rootState.popups.items.somethingWentWrong.name}, {root: true});
                reject(error)
            });

        })

    },
    registration(context){
        return new Promise((resolve, reject) => {
            axios.put(process.env.VUE_APP_API_PATH+'/user/users/',{},{
                headers: {'Content-Type': 'application/json;charset=utf-8','Authorization': localStorage.getItem('token') !== 'false' && localStorage.getItem('token') !== null && localStorage.getItem('token') !== undefined ? localStorage.getItem('token') : false},
                withCredentials: true,
                params: {
                    firstName: context.state.forms.registration.fields.firstName.value,
                    /*lastName: context.state.forms.registration.fields.lastName.value,
                    secondName: context.state.forms.registration.fields.secondName.value,
                    email: context.state.forms.registration.fields.email.value,*/
                },
                paramsSerializer: function(params) {
                    return qs.stringify(params, {arrayFormat: 'repeat'})
                },
            }).then(response => {
                if(typeof response.data === 'object' && +response.data.error === 0) {
                    app.$router.push('/personal');
                    context.commit('users/setUser',response.data.result,{root:true});
                    resolve();
                } else {
                    if( +response.data.error===401){
                        context.dispatch('auth/logout',{},{root:true})
                    }
                }
            }).catch(function (error) {
                context.commit('popups/open', {name: context.rootState.popups.items.somethingWentWrong.name}, {root: true});
                reject(error)
            });
        })
    },
    sendLog(context, data) {
        //send log
        function browser() {
            let ua= navigator.userAgent, tem,
                M= ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
            if(/trident/i.test(M[1])){
                tem=  /\brv[ :]+(\d+)/g.exec(ua) || [];
                return 'IE '+(tem[1] || '');
            }
            if(M[1]=== 'Chrome'){
                tem= ua.match(/\b(OPR|Edge)\/(\d+)/);
                if(tem!= null) return tem.slice(1).join(' ').replace('OPR', 'Opera');
            }
            M= M[2]? [M[1], M[2]]: [navigator.appName, navigator.appVersion, '-?'];
            if((tem= ua.match(/version\/(\d+)/i))!= null) M.splice(1, 1, tem[1]);
            return M.join(' ');
        }

        let params = new FormData();

        params.append('page', window.location.href);
        params.append('token', window.localStorage.getItem('token'));
        params.append('clientTime', new Date());
        params.append('browser', browser());

        axios.post(process.env.VUE_APP_API_PATH+'/rules/logger/', params, {
            headers: {
                'Content-Type': 'application/json;charset=utf-8',
                'Authorization': localStorage.getItem('token') !== 'false' && localStorage.getItem('token') !== null && localStorage.getItem('token') !== undefined ? localStorage.getItem('token') : false
            },
            withCredentials: true,
        })
        //end send log
    },
    logout(context,data) {
        context.dispatch('auth/sendLog',{},{root:true})
        if(window.app.localStorage){
            window.app.localStorage.token = false;
        }
        context.commit('users/setUser', {user:{}},{root: true});
        if(context.rootState.userCoupons){
            context.commit('userCoupons/setCouponList', {items:[]},{root: true});
        }
        /*if(window.app.$route.name === 'personal'){
            window.app.$router.push('/')
        }*/
        context.commit('setFormAuthField', {
            name: 'login',
            value:'',
        })
        context.commit('setFormAuthDisabled',{
            name: 'login',
            value: false
        });
        //context.commit('actions/setCouponDetailBuy', false,{root: true});
        context.commit('setStep',{ step:1 })
        context.commit('clearForms')
        if(context.rootState.partner){

            context.commit('partner/setLoaded',false,{root: true})
            context.commit('partner/setCurrentField', {
                name: 'success',
                value: false,
            },{root: true})
            context.commit('partner/setLoaded',true,{root: true})
        }
        window.scroll(0,0);
        context.commit('rules/setTopSections', { items: [] }, { root: true });
    },
    clearUserAuthInfo(context) {
        localStorage.setItem('token', 'false');
        context.commit('users/setUser', {user:{}},{root: true});
        if(context.rootState.userCoupons){
            context.commit('userCoupons/setCouponList', {items:[]},{root: true});
        }
    }
}

const mutations = {
    setFormAuthField(state, data) {
        if(state.forms.auth.fields.hasOwnProperty(data.name)) {
            state.forms.auth.fields[data.name].value = data.value
        }
    },
    setFormAuthError(state, data) {
        if(state.forms.auth.fields.hasOwnProperty(data.name)) {
            if(state.forms.auth.fields[data.name].error && data.value == true){
                state.forms.auth.fields[data.name].error = false;
                setTimeout(() => {
                    state.forms.auth.fields[data.name].error = true;
                });
            }else{
                state.forms.auth.fields[data.name].error = data.value;
            }
        }
    },
    setFormAuthDisabled(state, data) {
        if(state.forms.auth.fields.hasOwnProperty(data.name)) {
            state.forms.auth.fields[data.name].disabled = data.value
        }
    },
    setFormAuthFocus(state, data) {
        if(state.forms.auth.fields.hasOwnProperty(data.name)) {
            state.forms.auth.fields[data.name].focus = data.value
        }
    },
    setFormRegistrationField(state, data) {
        if(state.forms.registration.fields.hasOwnProperty(data.name)) {
            state.forms.registration.fields[data.name].value = data.value
        }
    },
    setFormRegistrationError(state, data) {
        if(state.forms.registration.fields.hasOwnProperty(data.name)) {
            state.forms.registration.fields[data.name].error = data.value
        }
    },
    setFormRegistrationDisabled(state, data) {
        if(state.forms.registration.fields.hasOwnProperty(data.name)) {
            state.forms.registration.fields[data.name].disabled = data.value
        }
    },
    setTimerTime(state, data) {
        state.forms.auth.timer.time = data
    },
    decrementTimerTime(state) {
        state.forms.auth.timer.time--
    },
    clearInterval(state) {

        state.forms.auth.timer.intervalId = false
    },
    setInterval(state, data) {
        state.forms.auth.timer.intervalId = data
    },
    setStep(state, data) {
        if(!!data && data.step > 0){
            state.forms.auth.step = data.step
        }
    },
    setIsValidPhone(state, data) {
        Vue.set(state, 'isValidPhone', data);
    },
    setBan(state, data) {
        state.isBanned = data
    },
    setBanPermanent(state, data) {
        state.isBannedPermanent = data
    },
    setBanPartner(state, data) {
        state.isBannedPartner = data
    },
    setIsNoSuccess(state, data) {
        state.isNoSuccess = data
    },
    setIsNoSuccessSection(state, data) {
        state.isNoSuccessSection = data
    },
    setIsRedirect(state, data) {
        state.isRedirect = data
    },
    setSmsBan(state, data){
        state.forms.auth.timer.smsBan = true;
        state.forms.auth.timer.timeBan = data.bannedTime;
    },
    clearForms(state){
        Vue.set(state, 'forms', {
            auth: {
                fields: {
                    login: {
                        name: 'login',
                        value: '',
                        required: true,
                        error: false,
                        errorText: 'Некорректный номер',
                        disabled: false
                    },
                    password: {
                        name: 'password',
                        value: '',
                        required: true,
                        error: false,
                        errorText: 'Неверный код',
                        disabled: false
                    }
                },
                step: 1,
                timer: {
                    time: 0,
                    timeDefault: 30,
                    intervalId: false,
                    smsBan: false,
                    timeBan: 0
                }
            },
            registration: {
                fields: {
                    firstName: {
                        name: 'firstName',
                        value: '',
                        required: true,
                        error: false,
                        errorText: 'Обязательное поле',
                        disabled: false
                    },
                    /*lastName: {
                        name: 'lastName',
                        value: '',
                        required: true,
                        error: false,
                        errorText: 'Обязательное поле',
                        disabled: false
                    },
                    secondName: {
                        name: 'secondName',
                        value: '',
                        required: true,
                        error: false,
                        errorText: 'Обязательное поле',
                        disabled: false
                    },
                    email: {
                        name: 'email',
                        value: '',
                        required: true,
                        error: false,
                        errorText: 'Некорректный e-mail',
                        disabled: false
                    }*/
                },
            }
        });
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
